/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_Select_JobInputs */

const en_cover_letters_select_job = /** @type {(inputs: Cover_Letters_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job...`)
};

const de_cover_letters_select_job = /** @type {(inputs: Cover_Letters_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stelle auswählen...`)
};

const fr_cover_letters_select_job = /** @type {(inputs: Cover_Letters_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner un emploi...`)
};

const es_cover_letters_select_job = /** @type {(inputs: Cover_Letters_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar un empleo...`)
};

const it_cover_letters_select_job = /** @type {(inputs: Cover_Letters_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un lavoro...`)
};

const nl_cover_letters_select_job = /** @type {(inputs: Cover_Letters_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecteer een baan...`)
};

const pl_cover_letters_select_job = /** @type {(inputs: Cover_Letters_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz ofertę pracy...`)
};

const fi_cover_letters_select_job = /** @type {(inputs: Cover_Letters_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valitse työpaikka...`)
};

const da_cover_letters_select_job = /** @type {(inputs: Cover_Letters_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vælg et job...`)
};

const sv_cover_letters_select_job = /** @type {(inputs: Cover_Letters_Select_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välj ett jobb...`)
};

/**
* | output |
* | --- |
* | "Select a job..." |
*
* @param {Cover_Letters_Select_JobInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_select_job = /** @type {((inputs?: Cover_Letters_Select_JobInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Select_JobInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_select_job(inputs)
	if (locale === "fr") return fr_cover_letters_select_job(inputs)
	if (locale === "es") return es_cover_letters_select_job(inputs)
	if (locale === "it") return it_cover_letters_select_job(inputs)
	if (locale === "nl") return nl_cover_letters_select_job(inputs)
	if (locale === "pl") return pl_cover_letters_select_job(inputs)
	if (locale === "fi") return fi_cover_letters_select_job(inputs)
	if (locale === "da") return da_cover_letters_select_job(inputs)
	if (locale === "sv") return sv_cover_letters_select_job(inputs)
	return en_cover_letters_select_job(inputs)
});